module.exports = __webpack_public_path__ + "img/Calender.bc57cc0a.svg";